import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Button, SelectInput } from "@life-line-lab/components-react";
import { Col, Row, DatePicker, Tooltip, Switch } from "antd";
import { LoadingOutlined, QuestionCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import { isEmpty } from "lodash"

interface ReportFilters {
  handleFilterChange: any;
  filterState: any;
  handleDownloadExcelFile: any;
  excelType?: string;
  reportListing: any;
  statusOptions: any;
  sortByCreatedAt: any;
  customDateLabel?: any;
  enableDownload?: any;
  disableShowLatestStatus?: any;
  handleRefreshList?: any;
  isLoading?: any;
  isExcelLoading?: any;
  additionalComponent?: any;
}

const ReportFilters: React.FC<ReportFilters> = ({
  handleFilterChange,
  filterState,
  handleDownloadExcelFile,
  excelType,
  reportListing,
  statusOptions,
  sortByCreatedAt,
  customDateLabel,
  enableDownload = true,
  disableShowLatestStatus = false,
  handleRefreshList,
  isLoading,
  isExcelLoading = false,
  additionalComponent,
}) => {
  const { t } = useTranslation();

  return (
    <Row className="dm-filters">
      <Col span={12} xl={20}>
        <Row gutter={[16, 16]}>
          <Col span={12} xl={6}>
            <div className="mb-7">
              {customDateLabel
                ? customDateLabel + " " + t("label.from")
                : t("label.from")}
            </div>
            <DatePicker
              placeholder="YYYY-MM-DD"
              value={
                filterState.dateFrom ? moment(filterState.dateFrom) : undefined
              }
              onChange={(value) => handleFilterChange(value, "dateFrom")}
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={12} xl={6}>
            <div className="mb-7">
              {customDateLabel
                ? customDateLabel + " " + t("label.to")
                : t("label.to")}
            </div>
            <DatePicker
              value={filterState.dateTo ? moment(filterState.dateTo) : moment()}
              onChange={(value) => handleFilterChange(value, "dateTo")}
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={12} xl={6}>
            <div className="mb-7">{t("label.sort")}</div>
            <SelectInput
              showSearch
              placeholder="Select option"
              options={sortByCreatedAt}
              value={filterState?.sortByCreatedAt}
              filterOption={(inputValue, option) =>
                option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >=
                0
              }
              onChange={(value) => {
                handleFilterChange(value, "sortByCreatedAt");
              }}
            />
          </Col>
          <Col span={12} xl={6}>
            {!isEmpty(statusOptions) && (
              <>
                <div className="mb-7">{t("label.status")}</div>
                <SelectInput
                  showSearch
                  placeholder="Select status"
                  options={statusOptions}
                  value={filterState?.status}
                  filterOption={(inputValue, option) =>
                    option.label
                      .toLowerCase()
                      .indexOf(inputValue.toLowerCase()) >= 0
                  }
                  onChange={(value) => {
                    handleFilterChange(value, "status");
                  }}
                />
              </>
            )}
          </Col>
          {!disableShowLatestStatus && (
            <Col span={12} xl={6}>
              <div className="mb-7 rf-field">
                {t("label.showLatestStatus")}{" "}
                <Tooltip placement="top" title={t("txt.showLatestStatus")}>
                  <QuestionCircleOutlined style={{ fontSize: "16px " }} />
                </Tooltip>
              </div>
              <Switch
                onChange={(value) => {
                  handleFilterChange(value, "onlyLatestStatus");
                }}
              />
            </Col>
          )}
          {additionalComponent}
          {handleRefreshList && (
            <Col span={12} xl={6}>
              <div className="mb-7 rf-field">{t("label.refreshList")}</div>
              <Button
                icon={isLoading ? <LoadingOutlined /> : <ReloadOutlined />}
                isDisabled={isLoading}
                onClick={() => handleRefreshList()}
                shape="circle"
              />
            </Col>
          )}
        </Row>
      </Col>
      {enableDownload && (
        <Col span={12} xl={4}>
          <div className="dmf-confirm dmf-dl">
            <Button
              type="secondary"
              isLoading={isExcelLoading}
              label={
                isExcelLoading
                  ? t("label.generatingReport")
                  : t("action.downloadReports")
              }
              onClick={() => handleDownloadExcelFile(reportListing, excelType)}
            />
          </div>
        </Col>
      )}
    </Row>
  );
};

export default ReportFilters;
